/* voyado-onsite.js
 * Voyado onsite messaging (Redeal) — standard tags only.
 *
 * Loads https://static.redeal.se/widget/js/redeal.js once the visitor has
 * granted consent, then fires ONE tag per page:
 *   - logged in, first page of the session → redeal('login', { email })
 *   - everything else                      → redeal('cornerwidget')
 * Voyado's docs: the login call must run once per session and not together
 * with cornerwidget on the same page.
 *
 * Messages only show on domains configured in Voyado Onsite Manager.
 *
 * The widget is not injected until consent is confirmed, so a visitor who
 * declines (or hasn't decided) makes no request to redeal.se. Shopify's consent
 * API returns undefined until the consent-tracking-api feature is loaded, so we
 * load it first (same approach as voyado-consent.js), then react to
 * `visitorConsentCollected` for visitors who decide later.
 */
(function () {
  var LOADER_SRC = 'https://static.redeal.se/widget/js/redeal.js';
  var LOGIN_FLAG = 'voyado-onsite-login';
  // Onsite is lead-capture / popups → marketing consent. voyado-consent.js gates
  // Elevate on analytics; switch to 'analyticsProcessingAllowed' to match it.
  var CONSENT_CHECK = 'marketingAllowed';

  var started = false;

  function readConfig() {
    try {
      return JSON.parse(document.getElementById('voyado-onsite-config').textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function consentGranted() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    return !!(cp && typeof cp[CONSENT_CHECK] === 'function' && cp[CONSENT_CHECK]());
  }

  function loadConsentApi(done) {
    var finished = false;
    function finish() { if (!finished) { finished = true; done(); } }
    try {
      var lf = window.Shopify && window.Shopify.loadFeatures;
      if (typeof lf !== 'function') return finish();
      lf([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      setTimeout(finish, 1500); // callback isn't always invoked in async mode
    } catch (e) { finish(); }
  }

  function injectLoader() {
    // Voyado's loader snippet, verbatim apart from the src constant.
    (function (i, s, o, g, r, a, m) {
      i['RedealObject'] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date(); a = s.createElement(o),
      m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
    })(window, document, 'script', LOADER_SRC, 'redeal');
  }

  function loginPending() {
    try { return !sessionStorage.getItem(LOGIN_FLAG); } catch (e) { return false; }
  }

  function markLoggedIn() {
    try { sessionStorage.setItem(LOGIN_FLAG, '1'); } catch (e) { /* private mode */ }
  }

  function start() {
    if (started || !consentGranted()) return;
    started = true;

    injectLoader();

    var email = readConfig().email;
    if (email && loginPending()) {
      markLoggedIn();
      window.redeal('login', { email: email });
    } else {
      window.redeal('cornerwidget');
    }
  }

  document.addEventListener('visitorConsentCollected', start);
  loadConsentApi(start);
})();
